/**
 * @ngdoc filter
 * @name excludeKeys
 * @param {Object} obj The object to remove the keys from
 * @param {Array<string>} excludeThese The keys represented by these strings
 *                                     will be removed from the source object
 * @description
 * Returns an object with the provided keys removed from the source object.
 */

export function excludeKeysFilter() {
    return (obj, excludeThese) => {
        const result = {};
        Object.keys(obj).forEach((key) => {
            if (excludeThese.indexOf(key) === -1) {
                result[key] = obj[key];
            }
        });
        return result;
    };
}
